import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get('https://kidsworkrehab.onrender.com/api/services');
        setServices(response.data);
      } catch (err) {
        console.error('Error fetching services:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  return (
    <div className="bg-white py-[60px] px-5 min-h-screen font-sans">
      <div className="text-center mb-[50px]">
        <h1 className="text-[#1976d2] text-[3em] md:text-[2.2em] mb-[15px] font-bold bg-gradient-to-br from-[#1976d2] to-[#1e88e5] bg-clip-text text-transparent">Our Services</h1>
        <p className="text-[#424242] text-[1.2em] font-light max-w-[600px] mx-auto">
          Comprehensive therapy and rehabilitation services tailored for every child's unique needs
        </p>
      </div>

      {loading ? (
        <div className="text-center py-[60px] px-5 text-[#1976d2] text-[1.2em]">Loading services...</div>
      ) : services.length === 0 ? (
        <div className="text-center py-[60px] px-5 text-[#999] text-[1.2em]">
          No services available at the moment. Please check back later.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-[repeat(auto-fit,minmax(350px,1fr))] gap-[30px] md:gap-[20px] max-w-[1200px] mx-auto px-5 md:px-[20px]">
          {services.map((service) => (
            <div key={service._id} className="bg-white rounded-[16px] p-[35px] md:p-[25px] shadow-[0_4px_20px_rgba(25,118,210,0.12)] transition-all duration-300 border-2 border-[#1e88e5]/10 relative overflow-hidden hover:-translate-y-[8px] hover:shadow-[0_8px_30px_rgba(25,118,210,0.2)] before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-[4px] before:bg-gradient-to-r before:from-[#1e88e5] before:to-[#1976d2] before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
              {service.imageUrl && (
                <img
                  src={service.imageUrl}
                  alt={service.name}
                  className="w-full h-[250px] object-cover rounded-[12px] mb-[20px] shadow-[0_4px_15px_rgba(0,0,0,0.1)]"
                />
              )}
              <h2 className="text-[#1976d2] text-[1.8em] mb-[15px] font-semibold">{service.name}</h2>
              <p className="text-[#424242] text-[1.05em] leading-[1.8] m-0">{service.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Services;

